import React, { useEffect, useState } from "react";
import client from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import ModifierModal from "@/components/ModifierModal";
import { useCart } from "@/context/CartContext";
import { useContent } from "@/context/ContentContext";
import { toast } from "sonner";

export default function Specials() {
    const c = useContent();
    const sp = c.specials_page || {};
    const [specials, setSpecials] = useState([]);
    const [bundles, setBundles] = useState([]);
    const [dinners, setDinners] = useState([]);
    const [selected, setSelected] = useState(null);
    const { addLine } = useCart();

    useEffect(() => {
        client.get("/specials", { params: { section: "specials" } }).then((r) => setSpecials(r.data));
        client.get("/specials", { params: { section: "bundles" } }).then((r) => setBundles(r.data));
        client.get("/specials", { params: { section: "pre-cooked-dinners" } }).then((r) => setDinners(r.data));
    }, []);

    const handleSelect = (item) => {
        if (!item.modifiers?.length) {
            addLine({
                item_id: item.id,
                name: item.name,
                price: Number(item.price),
                quantity: 1,
                modifiers: [],
                line_total: Number(item.price),
            });
            toast.success(`${item.name} added`);
        } else setSelected(item);
    };

    const Section = ({ title, description, items }) =>
        items.length === 0 ? null : (
            <section className="mt-16">
                <p className="font-script text-brand-gold text-4xl">{title}</p>
                <p className="text-brand-mute mt-1 max-w-xl">{description}</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                    {items.map((it) => <ProductCard key={it.id} item={it} onSelect={handleSelect} />)}
                </div>
            </section>
        );

    return (
        <div className="container-wide py-14">
            <p className="font-script text-brand-gold text-3xl">{sp.script || "High-margin"}</p>
            <h1 className="font-display text-4xl md:text-5xl mt-1">{sp.title || "Specials & Bundles"}</h1>
            <p className="mt-3 max-w-2xl text-brand-mute">
                {sp.subtitle || "Family-size frozen meals, burger combo deals, and weekend breakfast packs. Perfect for team lunches, weeknight dinners, and weekend gatherings."}
            </p>

            <Section title="Daily Specials" description="Rotating chef's plates and soup — freshly prepared today." items={specials} />
            <Section title="Bundles & Combos" description="Combo packs, office lunch boxes, and family value." items={bundles} />
            <Section title="Pre-Cooked Dinners" description="Frozen family meals — heat, serve, enjoy." items={dinners} />

            <ModifierModal
                open={!!selected}
                onOpenChange={(o) => !o && setSelected(null)}
                item={selected}
                onAdd={(l) => { addLine(l); toast.success("Added to cart"); }}
            />
        </div>
    );
}
